class Megamenu {
  constructor(container) {
    this.selectors = {
      announcementBar: ".m-announcement-bar",
      hamburgerButton: ".m-menu-button",
      hamburgerIcon: ".m-hamburger-box",
      desktopMenuItems: [".m-menu__item"],
      desktopSubMenus: ".m-mega-menu",
      headerMobile: ".m-header__mobile",
      menuDrawer: "#m-menu-drawer",
      menuDrawerContent: ".m-menu-drawer__content",
      menu: ".m-menu-mobile",
      menuItems: [".m-menu-mobile__item"],
      megaMenuMobile: [".m-megamenu-mobile"],
      backDrop: ".m-menu-drawer__backdrop",
    };

    this.menuSelectors = {
      subMenu: ".m-mega-menu",
    };

    this.activeDesktopMenuItem = null;
    this.sliders = {};
    this.open = false;
    this.container = container;
    this.transitionDuration = 0;
    this.domNodes = queryDomNodes(this.selectors, this.container);

    this.menuData = [...(this.domNodes.desktopMenuItems || [])].map((item) => {
      const header = item.closest("header");
      const menuNodes = queryDomNodes(this.menuSelectors, item);
      return { header, item, ...menuNodes, active: false };
    });

    this.init();

    window.MinimogTheme = window.MinimogTheme || {};
    window.MinimogTheme.headerSliders = this.sliders;
  }

  init() {
    const { hamburgerButton, backDrop } = this.domNodes;

    if (hamburgerButton) {
      hamburgerButton.addEventListener("click", this.handleHamburgerClick);
    }

    if (backDrop) {
      backDrop.addEventListener("click", this.closeMenu);
    }

    this.initMobileMegaMenu();
    this.initDesktopMegaMenu();

    if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, () => {
        if (this.open) this.closeMenu();
      });

      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openSearchPopup, () => {
        if (this.open) this.closeMenu();
      });
    }
  }

  handleHamburgerClick = (e) => {
    e.preventDefault();

    const willOpen = !this.open;
    const hamburgerIcon = this.domNodes.hamburgerIcon;

    if (willOpen) {
      this.openMenu();
    } else {
      this.closeMenu();
    }

    if (hamburgerIcon) {
      hamburgerIcon.classList.toggle("active", willOpen);
    }
  };

  initDesktopMegaMenu() {
    [...this.menuData].forEach((menuItem) => {
      const { subMenu } = menuItem;

      if (subMenu) {
        const productsBanner = subMenu.querySelector(".m-mega-product-list");
        if (productsBanner) {
          if (window && window.__sfWindowLoaded) {
            menuItem.productsBannerSlider = this.initProductsBanner(productsBanner);
          } else {
            window.addEventListener("load", () => {
              menuItem.productsBannerSlider = this.initProductsBanner(productsBanner);
            });
          }
        }
      }
    });
  }

  closeDesktopSubmenu = (menuItemIndex) => {
    const menuItem = this.menuData[menuItemIndex];
    if (!menuItem) return;

    const { header } = menuItem;
    if (header) {
      header.classList.remove("show-menu");
    }
  };

  initProductsBanner(banner) {
    const header = banner.closest("header");
    const menuItem = banner.closest(".m-menu__item");
    const screenClass = (header && `.${header.dataset.screen}`) || "";

    const id = banner.dataset.id;
    const sliderContainer = document.querySelector(`.m-product-list-${id}`);
    if (!sliderContainer) return null;

    const columns = Number(sliderContainer.dataset.column || 1);

    const slider = new MinimogLibs.Swiper(`${screenClass} .m-product-list-${id}`, {
      slidesPerView: 1,
      loop: false,
      autoplay: false,
      breakpoints: {
        1200: { slidesPerView: columns },
        992: { slidesPerView: columns >= 2 ? 2 : columns },
      },
    });

    if (menuItem) {
      this.sliders[menuItem.dataset.index] = slider;
    }

    if (slider) {
      const prevBtn = document.querySelector(`#m-slider-controls-${id} .m-slider-controls__button-prev`);
      const nextBtn = document.querySelector(`#m-slider-controls-${id} .m-slider-controls__button-next`);

      if (prevBtn) {
        prevBtn.addEventListener("click", () => slider.slidePrev());
      }

      if (nextBtn) {
        nextBtn.addEventListener("click", () => slider.slideNext());
      }
    }

    return slider;
  }

  initMobileMegaMenu() {
    [...(this.domNodes.menuItems || [])].forEach((item) => {
      const subMenuContainer = item.querySelector(".m-megamenu-mobile");
      const backBtn = item.querySelector(".m-menu-mobile__back-button");

      if (subMenuContainer) {
        addEventDelegate({
          context: item,
          selector: "[data-toggle-submenu]",
          handler: (e, target) => {
            const trigger = target.closest("[data-toggle-submenu]") || target;

            if (!trigger || trigger.classList.contains("m-menu-mobile__back-button") || trigger.closest(".m-menu-mobile__back-button")) {
              return;
            }

            e.preventDefault();

            const level = trigger.dataset.toggleSubmenu;
            if (!level) return;

            this.openSubMenu(subMenuContainer, level);
          },
        });
      }

      if (backBtn) {
        backBtn.addEventListener("click", (e) => {
          e.preventDefault();

          const level = e.currentTarget.dataset.level;
          if (!level) return;

          this.closeSubMenu(subMenuContainer, level);
        });
      }
    });

    document.addEventListener("matchMobile", this.setMenuHeight);
    document.addEventListener("unmatchMobile", this.setMenuHeight);
    window.addEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    if (this.open) {
      this.setMenuHeight();
    }
  };

  openMenu() {
    this.setMenuHeight();

    document.documentElement.classList.add("prevent-scroll");

    if (this.domNodes.menuDrawer) {
      this.domNodes.menuDrawer.classList.add("open");
    }

    if (this.domNodes.headerMobile) {
      this.domNodes.headerMobile.classList.add("header-drawer-open");
    }

    this.open = true;
    this.updateDrawerEnhancements();
  }

  closeMenu = () => {
    const { menuDrawer, menu, megaMenuMobile, hamburgerIcon, menuDrawerContent } = this.domNodes;

    if (megaMenuMobile && megaMenuMobile.length) {
      megaMenuMobile.forEach((container) => {
        container.classList.remove("open");
      });
    }

    if (menu) {
      menu.classList.remove("m-submenu-open", "m-submenu-open--level-1", "m-submenu-open--level-2");
    }

    if (menuDrawerContent) {
      menuDrawerContent.classList.remove("open-submenu");
    }

    if (menuDrawer) {
      menuDrawer.classList.remove("open");
    }

    document.documentElement.classList.remove("prevent-scroll");

    if (this.domNodes.headerMobile) {
      this.domNodes.headerMobile.classList.remove("header-drawer-open");
    }

    if (hamburgerIcon) {
      hamburgerIcon.classList.remove("active");
    }

    this.open = false;
  };

  openSubMenu(subMenuContainer, level) {
    const subMenuOpenClass = `m-submenu-open--level-${level}`;

    if (this.domNodes.menuDrawerContent) {
      this.domNodes.menuDrawerContent.classList.add("open-submenu");
    }

    if (this.domNodes.menu) {
      this.domNodes.menu.classList.add("m-submenu-open");
      this.domNodes.menu.classList.add(subMenuOpenClass);
    }

    if (subMenuContainer) {
      subMenuContainer.classList.add("open");
    }
  }

  closeSubMenu(subMenuContainer, level) {
    const subMenuOpenClass = `m-submenu-open--level-${level}`;

    if (level === "1" && this.domNodes.menu) {
      this.domNodes.menu.classList.remove("m-submenu-open");
    }

    if (this.domNodes.menu) {
      this.domNodes.menu.classList.remove(subMenuOpenClass);
    }

    if (subMenuContainer) {
      subMenuContainer.classList.remove("open");
    }

    if (this.domNodes.menuDrawerContent) {
      this.domNodes.menuDrawerContent.classList.remove("open-submenu");
    }
  }

  setMenuHeight = () => {
    const { menuDrawer, headerMobile } = this.domNodes;

    if (!menuDrawer || !headerMobile) return;

    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const offsetBottom = headerMobile.getBoundingClientRect().bottom;
    const panelHeight = Math.max(viewportHeight - offsetBottom, 0);

    menuDrawer.style.setProperty("--menu-drawer-height", `${panelHeight}px`);
  };

  updateDrawerEnhancements = async () => {
    const cart = await this.fetchCart();
    this.updateFreeShippingProgress(cart);
    this.updateTieredGifts(cart);
  };

  async fetchCart() {
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      const response = await fetch(`${root}cart.js`, {
        method: "GET",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
        },
      });

      if (!response.ok) return null;
      return await response.json();
    } catch (error) {
      return null;
    }
  }

  updateFreeShippingProgress(cart) {
    const bars = this.container.querySelectorAll("[data-drawer-free-shipping]");
    if (!bars.length) return;

    const cartTotal = cart ? Number(cart.total_price || 0) : null;

    bars.forEach((bar) => {
      const threshold = Number(bar.dataset.threshold || 0);
      if (!(threshold > 0)) return;

      const current = cartTotal !== null ? cartTotal : Number(bar.dataset.cartTotal || 0);
      const remaining = Math.max(threshold - current, 0);
      const progress = Math.min((current / threshold) * 100, 100);

      const messageRemaining = bar.dataset.messageRemaining || "اضف بقيمة [amount] للحصول على شحن مجاني";
      const messageSuccess = bar.dataset.messageSuccess || "لقد حصلت على شحن مجاني";

      const textNode = bar.querySelector("[data-free-shipping-text]");
      const fillNode = bar.querySelector("[data-free-shipping-fill]");
      const percentNode = bar.querySelector("[data-free-shipping-percent]");
      const currentNode = bar.querySelector("[data-free-shipping-current]");
      const goalNode = bar.querySelector("[data-free-shipping-goal]");

      const remainingMoney = this.formatMoney(remaining);
      const currentMoney = this.formatMoney(current);
      const goalMoney = this.formatMoney(threshold);

      if (textNode) {
        textNode.textContent =
          remaining > 0
            ? messageRemaining.replace("[amount]", remainingMoney)
            : messageSuccess;
      }

      if (fillNode) {
        fillNode.style.width = `${progress}%`;
      }

      if (percentNode) {
        percentNode.textContent = `${Math.round(progress)}%`;
      }

      if (currentNode) {
        currentNode.textContent = currentMoney;
      }

      if (goalNode) {
        goalNode.textContent = goalMoney;
      }

      bar.classList.toggle("is-complete", remaining === 0);
      bar.dataset.cartTotal = current;
    });
  }

  updateTieredGifts(cart) {
    const widgets = this.container.querySelectorAll("[data-drawer-tiered-gifts]");
    if (!widgets.length) return;

    const cartTotal = cart ? Number(cart.total_price || 0) : null;

    widgets.forEach((widget) => {
      const current = cartTotal !== null ? cartTotal : Number(widget.dataset.cartTotal || 0);
      const items = widget.querySelectorAll("[data-tier-threshold]");

      items.forEach((item) => {
        const threshold = Number(item.dataset.tierThreshold || 0);
        const valueNode = item.querySelector("[data-tier-value]");
        const unlocked = current >= threshold;

        item.classList.toggle("is-unlocked", unlocked);

        if (valueNode) {
          valueNode.textContent = this.formatMoney(threshold);
        }
      });

      widget.dataset.cartTotal = current;
    });
  }

  formatMoney(cents) {
    const numericCents = Number(cents || 0);

    if (Number.isNaN(numericCents)) {
      return "0 ج.م";
    }

    const amount = Math.round(numericCents / 100).toLocaleString("en-US");
    return `${amount} ج.م`;
  }
}

class SiteNav {
  constructor(container) {
    this.selectors = {
      menuItems: [".m-menu .m-menu__item"],
      dropdowns: [".m-mega-menu"],
      subMenu: ".m-mega-menu",
      overlay: ".m-header__overlay",
      swiper: ".swiper-container",
    };

    this.classes = {
      slideFromRight: "slide-from-right",
      slideReveal: "slide-reveal",
      active: "m-mega-active",
    };

    this.headerSticky = false;

    if (!container) return;

    this.container = container;
    this.domNodes = queryDomNodes(this.selectors, this.container);
    this.activeIndex = -1;
    this.lastActiveIndex = -1;
    this.visited = false;
    this.timeoutEnter = null;
    this.timeoutLeave = null;
    this.attachEvents();
  }

  attachEvents = () => {
    (this.domNodes.menuItems || []).forEach((menuItem, index) => {
      menuItem.addEventListener("mouseenter", (evt) => this.onMenuItemEnter(evt, index));
      menuItem.addEventListener("mouseleave", (evt) => this.onMenuItemLeave(evt, index));
    });
  };

  initDropdownSize = () => {
    if (this.container) {
      this.container.style.setProperty("--sf-dropdown-width", this.windowWidth());
      this.container.style.setProperty("--sf-dropdown-height", this.windowHeight());
    }
  };

  onMenuItemEnter = (evt, index) => {
    const { target } = evt;

    if (!target.classList.contains("m-menu__item--mega")) return;

    clearTimeout(this.timeoutLeave);

    this.activeIndex = target.dataset && Number(target.dataset.index);
    this.headerSticky = this.container && this.container.dataset.sticky !== "none";
    this.reInitSlider(target);

    if (this.container) {
      this.visited
        ? this.container.classList.remove(this.classes.slideReveal)
        : this.container.classList.add(this.classes.slideReveal);
    }

    this.visited = true;

    if (this.lastActiveIndex >= 0 && this.activeIndex >= 0 && this.container) {
      if (this.lastActiveIndex < this.activeIndex) {
        this.container.classList.add(this.classes.slideFromRight);
      } else if (this.lastActiveIndex > this.activeIndex) {
        this.container.classList.remove(this.classes.slideFromRight);
      }
    }

    this.getElementBoundingRect(target).then((rect) => {
      if (rect && this.container) {
        this.container.style.setProperty("--sf-dropdown-width", rect.width);
        this.container.style.setProperty("--sf-dropdown-height", rect.height);
      }

      this.timeoutEnter = setTimeout(() => {
        if (this.activeIndex !== Number(target.dataset.index)) return;

        if (this.container) {
          this.container.classList.add(this.classes.active);
        }

        const currentItem = target.closest(".m-menu__item");
        if (currentItem) {
          currentItem.classList.add("m-menu__item--active");
        }
      }, 120);
    });
  };

  onMenuItemLeave = (evt, index) => {
    this.activeIndex = -1;
    this.lastActiveIndex = index;

    const currentItem = evt.target.closest(".m-menu__item");
    if (currentItem) {
      currentItem.classList.remove("m-menu__item--active");
    }

    this.timeoutLeave = setTimeout(() => {
      if (this.activeIndex === -1 || this.activeIndex < 0) {
        this.visited = false;
      }
      this.resetMegaMenu();
    }, 80);
  };

  reInitSlider = (menuItem) => {
    const swiper = menuItem.querySelector(this.selectors.swiper);
    if (!swiper) return;

    const itemIndex = menuItem.dataset.index;
    const slider = window.MinimogTheme && window.MinimogTheme.headerSliders[itemIndex];

    if (slider && typeof slider.update === "function") {
      slider.update();
    }
  };

  getElementBoundingRect = async (element) => {
    const subMenu = element.querySelector(this.selectors.subMenu);
    if (!subMenu) return null;

    const rect = subMenu.getBoundingClientRect();
    return {
      width: rect.width,
      height: rect.height,
      left: rect.left,
      top: rect.top,
    };
  };

  resetMegaMenu = () => {
    this.activeIndex = -1;

    clearTimeout(this.timeoutEnter);

    if (this.container) {
      this.container.classList.remove(
        this.classes.active,
        this.classes.slideFromRight,
        this.classes.slideReveal,
        "sf-header--bg-black",
        "sf-header--bg-white"
      );
    }
  };

  windowWidth = () => window.innerWidth;
  windowHeight = () => window.innerHeight;
}